import { Component } from '@angular/core';
import packageJson from '../../../../package.json';
import { StorageService } from './services/StorageService';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import AOS from 'aos';
import { GoogleAnalyticsService } from './services/googleAnalytics.service';
import { environment } from '../../../../public/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  appTitle = 'general.Thrwty';
  public version: string = packageJson.version;
  isHome = false;

  hideLayout = false;

  constructor(
    public storageService: StorageService,
    private router: Router,
    private title: Title,
    private translate: TranslateService,
    private readonly googleAnalyticsService: GoogleAnalyticsService
  ) {
    if (environment.production) {
      this.googleAnalyticsService.initialize();
    }
    AOS.init({
      duration: 800,
      // offset: 120,
      easing: 'ease-in-out',
      // once: true
    });
    window.addEventListener('load', AOS.refresh);
    // this.storageService.changes.subscribe(data => {
    //   if (data?.key == 'language' || data?.key == 'authUser') {
    //     localStorage.removeItem('authUser');
    //     window.location.reload();
    //   }
    // });

    const urlParams = new URLSearchParams(window.location.search);
    let lang = urlParams.get('lang');

    if (!lang) {
      lang = localStorage.getItem('language') || 'ar';
      urlParams.set('lang', lang);
      const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
      window.history.replaceState({}, '', newUrl);
    }

    localStorage.setItem('language', lang);

    let style = 'assets/css/ar/style.css';
    let dir = 'rtl';
    if (lang === 'en') {
      style = 'assets/css/en/style.css';
      dir = 'ltr';
    }
    style += this.version ? `?vr=${this.version}` : '';
    document.getElementById('mainStyle')?.setAttribute('href', style);
    document.getElementById('html')?.setAttribute('lang', lang);
    document.getElementById('html')?.setAttribute('dir', dir);
  }


  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.setHeaderClass(event.urlAfterRedirects);
      });
    this.translate.get(this.appTitle).subscribe(title => {
      this.title.setTitle(title);
    });
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route: ActivatedRoute = this.router.routerState.root;
          let routeTitle = '';
          while (route!.firstChild) {
            route = route.firstChild;
          }
          if (route.snapshot.data['title']) {
            routeTitle = route!.snapshot.data['title'];
          }
          this.hideLayout = route?.snapshot.data['hideLayout'] === true;
          return routeTitle;
        })
      )
      .subscribe((title: string) => {
        if (title) {
          this.translate.get('header.' + title).subscribe(transTitle => {
            this.title.setTitle(`${this.translate.instant(this.appTitle)} - ${transTitle}`);
          });
        }
      });
  }

  private setHeaderClass(url: string) {
    this.isHome = false;
    if (url?.split('?')[0] == '/') {
      this.isHome = true;
    }
  }
}
